"use strict";
exports.__esModule = true;
exports.chart_tooltip_Fill = {
  "name": "--pf-chart-tooltip--Fill",
  "value": "#f0f0f0",
  "var": "var(--pf-chart-tooltip--Fill, #f0f0f0)"
};
exports["default"] = exports.chart_tooltip_Fill;